import React, { FC } from 'react'
import useSWR from 'swr'
import { useTranslation } from 'react-i18next'
import { useQueryParam, StringParam } from 'use-query-params'

import { StatusFilter } from 'components/StatusFilter'
import { NextScheduledContact } from 'components/Notifications/NextScheduledContact'
import { StatusUpdate } from 'components/Notifications/StatusUpdate'
import { fetchData } from 'services/api/core/assignments/workflowDetails'
import { getAssignments } from 'pipelines/assignments'

import { OrderBy } from '../OrderBy'
import { Assignment } from './Assignment'

const WorkflowDetails: FC = () => {
  const { t } = useTranslation(['surprise', 'common'])
  const { data } = useSWR<{ data: Workflow[] }>('workflow-details', () =>
    fetchData(t),
  )
  const assignments: Workflow[] = data?.data || []
  const [filter] = useQueryParam('filter', StringParam)
  const [search] = useQueryParam('search', StringParam)
  const [orderBy] = useQueryParam('orderBy', StringParam)
  const [orientation] = useQueryParam('orientation', StringParam)
  const safeOrientation = orientation || 'asc'

  const lines = getAssignments({
    assignments,
    search,
    filter,
    orderBy,
    orientation: safeOrientation,
    t,
  })

  return (
    <>
      <StatusFilter assignments={assignments} />
      <OrderBy />
      {lines.map(assignment => (
        <Assignment key={assignment.id} assignment={assignment} />
      ))}
      <StatusUpdate assignments={assignments} />
      <NextScheduledContact workflows={assignments} />
    </>
  )
}

export { WorkflowDetails }
